import React, { useState, useEffect, lazy, Suspense } from 'react';
import { Row, Col, Pagination, Skeleton } from 'antd';
import { useSelector } from 'react-redux';
import Heading from '../../components/heading/heading';
import { ProjectPagination } from '../project/style';
import { Cards } from '../../components/cards/frame/cards-frame';
const GridCard = lazy(() => import('./GridCard'));

function Grid({ value, handleFunctionClick, handleEditFunctionProp, handleDeleteStatusNotification }) {
    const [state, setState] = useState({
        projects: value || [],
        current: 1,
        pageSize: 6,
    });

    useEffect(() => {
        if (value) {
            setState((prevState) => ({
                ...prevState,
                projects: value,
                current: 1,
            }));
        }
    }, [value]);

    const { projects, current, pageSize } = state;

    const onHandleChange = (page, pageSize) => {
        setState({ ...state, current: page, pageSize });
    };

    const paginatedProjects = projects.slice((current - 1) * pageSize, current * pageSize);

    return (
        <>
            {paginatedProjects && paginatedProjects.length > 0 ? (
                paginatedProjects.map((value) => {
                    return (
                        <Col key={value.id} xl={8} md={12} xs={24}>
                            <Suspense
                                fallback={
                                    <Cards headless>
                                        <Skeleton active />
                                    </Cards>
                                }
                            >
                                <GridCard value={value} handleFunctionClick={handleFunctionClick} handleEditFunctionProp={handleEditFunctionProp} handleDeleteStatusNotification={handleDeleteStatusNotification} />
                            </Suspense>
                        </Col>
                    );
                })
            ) : (
                <Col md={24}>
                    <Cards headless>
                        <Heading>Data Not Found!</Heading>
                    </Cards>
                </Col>
            )}
            <Col xs={24} className="pb-30">
                <ProjectPagination>
                    {projects.length > 0 && (
                        <Pagination
                            current={current}
                            pageSize={pageSize}
                            total={projects.length}
                            onChange={onHandleChange}
                        />
                    )}
                </ProjectPagination>
            </Col>
        </>
    );
}

export default Grid;
